import * as React from "react";
import type { SVGProps } from "react";
const SvgSnowflake = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#snowflake_svg__a)">
      <path d="M12.39 7.79c-.26 0-.51-.1-.71-.29L8.84 4.66a.996.996 0 1 1 1.41-1.41l2.13 2.13 2.13-2.13a.996.996 0 1 1 1.41 1.41L13.08 7.5c-.2.2-.45.29-.71.29zM15.24 21.05c-.26 0-.51-.1-.71-.29l-2.13-2.13-2.13 2.13a.996.996 0 1 1-1.41-1.41l2.84-2.84a.996.996 0 0 1 1.41 0l2.84 2.84a.996.996 0 0 1-.71 1.7" />
      <path d="M12.39 22c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v18c0 .55-.45 1-1 1M6.84 19.49c-.09 0-.17-.01-.26-.03-.53-.14-.85-.69-.71-1.22l.78-2.92-2.92-.78c-.53-.14-.85-.69-.71-1.22s.69-.85 1.22-.71l3.88 1.04c.53.14.85.69.71 1.22l-1.04 3.88a.99.99 0 0 1-.96.74zM20.79 11.43c-.09 0-.17-.01-.26-.03l-3.88-1.04c-.53-.14-.85-.69-.71-1.22l1.04-3.88c.14-.53.69-.85 1.22-.71s.85.69.71 1.22l-.78 2.92 2.92.78c.53.14.85.69.71 1.22a.99.99 0 0 1-.96.74z" />
      <path d="M4.6 17.5a1.002 1.002 0 0 1-.5-1.87l15.59-9c.48-.28 1.09-.11 1.37.37s.11 1.09-.37 1.37l-15.59 9c-.16.09-.33.13-.5.13M17.95 19.49c-.44 0-.85-.29-.96-.74l-1.04-3.88a.994.994 0 0 1 .71-1.22l3.88-1.04a.99.99 0 0 1 1.22.71.994.994 0 0 1-.71 1.22l-2.92.78.78 2.92a.994.994 0 0 1-.97 1.25zM4 11.43c-.44 0-.85-.29-.96-.74a.994.994 0 0 1 .71-1.22l2.92-.78-.78-2.92a.994.994 0 0 1 .71-1.22.99.99 0 0 1 1.22.71l1.04 3.88a.994.994 0 0 1-.71 1.22L4.27 11.4c-.09.02-.17.03-.26.03z" />
      <path d="M20.19 17.5c-.17 0-.34-.04-.5-.13l-15.59-9A1.01 1.01 0 0 1 3.73 7c.28-.48.89-.64 1.37-.37l15.59 9c.48.28.64.89.37 1.37-.19.32-.52.5-.87.5" />
    </g>
    <defs>
      <clipPath id="snowflake_svg__a">
        <path fill="#fff" d="M3 2h18.79v20H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSnowflake;
